import { useMemo } from 'react';
import useMasonryDataStore from 'templates/stores/masonryDataStore';
import { formatTemplatesCount, getPaginationInfo } from 'templates/utils';
import useStyles from './styles';

const TemplatesCount = () => {
  const classes = useStyles();

  const { masonryData, isLoading } = useMasonryDataStore(state => ({
    masonryData: state.masonryData,
    isLoading: state.isLoading,
  }));

  const { total } = getPaginationInfo({ masonryData });

  const displayedTotal = useMemo(() => formatTemplatesCount(total), [total]);

  if (isLoading) {
    return null;
  }

  return (
    <div className={classes.root}>
      {displayedTotal && <span className={classes.text}>{`${displayedTotal} templates`}</span>}
    </div>
  );
};

export default TemplatesCount;
